export default __webpack_public_path__ + "static/assets/072d31ba1e692444f79563c109841d6d.png";